import * as lib from '../api/tenants.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const get = (id) => {
    return fetchLoadable(actionTypes.FETCH_TENANT, lib.get, { id });
};
export const update = (id, tenant, preventReload) => {
    return lib.update(id, tenant).then(() => {
        if (!preventReload)
            get(id);
    });
};
//# sourceMappingURL=actions.js.map